export default {
      id: "color_weight-usage",
      viewBox: "0 0 50 54",
      url: __webpack_public_path__ + "sprite.svg#color_weight",
      toString: function () {
        return this.url;
      }
    }